import { createContext } from 'react';

export interface ICancellationConfirmationPopupContext {
  cancelCurrentSubscription(): Promise<void>;
}

export const CancellationConfirmationPopupContext = createContext<ICancellationConfirmationPopupContext | null>(null);
export const CancellationConfirmationPopupConsumer = CancellationConfirmationPopupContext.Consumer;
